import {
  __decorateClass,
  component_styles_default,
  theme_styles_default
} from "./chunk.U4VUMZVF.js";

// src/components/dot-indicator/dot-indicator.ts
import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

// src/components/dot-indicator/dot-indicator.styles.ts
import { css } from "lit";
var dot_indicator_styles_default = css`
	${theme_styles_default}
	${component_styles_default}

	.dot-indicator {
		width: 10px; /* 0.625rem */
		height: 10px; /* 0.625rem */
		border-radius: var(--yotpo-border-radius-pill);
		border: 2px solid var(--yotpo-color-white); /* 0.125rem */
		box-sizing: border-box;
	}

	.dot-indicator--neutral {
		background-color: var(--yotpo-color-general-70);
	}

	.dot-indicator--primary {
		background-color: var(--yotpo-color-brand-70);
	}

	.dot-indicator--warning {
		background-color: var(--yotpo-color-warning-70);
	}

	.dot-indicator--danger {
		background-color: var(--yotpo-color-destructive-70);
	}

	.dot-indicator--success {
		background-color: var(--yotpo-color-success-70);
	}

	.dot-indicator--premium {
		background-color: var(--yotpo-color-premium-70);
	}
`;

// src/components/dot-indicator/dot-indicator.ts
var YotpoDotIndicator = class extends LitElement {
  constructor() {
    super(...arguments);
    this.status = "neutral" /* neutral */;
  }
  render() {
    return html`
          <div
              part="base"
              class=${classMap({
      "dot-indicator": true,
      "dot-indicator--neutral": this.status === "neutral" /* neutral */,
      "dot-indicator--primary": this.status === "primary" /* primary */,
      "dot-indicator--warning": this.status === "warning" /* warning */,
      "dot-indicator--danger": this.status === "danger" /* danger */,
      "dot-indicator--success": this.status === "success" /* success */,
      "dot-indicator--premium": this.status === "premium" /* premium */
    })}
              role="status"
          </div> `;
  }
};
YotpoDotIndicator.styles = dot_indicator_styles_default;
__decorateClass([
  property({ reflect: true })
], YotpoDotIndicator.prototype, "status", 2);
YotpoDotIndicator = __decorateClass([
  customElement("yotpo-dot-indicator")
], YotpoDotIndicator);

export {
  YotpoDotIndicator
};
